import { ITagOutputDto } from './tags-output-dto.interface';
import { IZoneOutputDto } from './zone-output-dto.interface';

export interface IGeocodingResultDto {
    resultType?: string;
}

export interface ILocationOutputDto {
    id: string;
    organizationId?: string;
    externalId?: string;
    name: string;
    isWarehouse?: boolean;
    // type: string;
    code: string;
    city?: string;
    state?: string;
    country?: string;
    latitude?: string;
    longitude?: string;
    addressLine1?: string;
    addressLine2?: string;
    geocodingResult?: IGeocodingResultDto;
    tags?: string[] | ITagOutputDto[];
    contactEmail?: string;
    contactPhone?: string;
    zones?: string[] | IZoneOutputDto[];
    createdAt?: string;
    updatedAt?: string;
    isStopOver?: boolean;
}
